import { render, staticRenderFns } from "./SettingsPass.vue?vue&type=template&id=56e8941e&"
import script from "./SettingsPass.vue?vue&type=script&lang=js&"
export * from "./SettingsPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports